/**
 * Base class for results from checking a transaction or reserve proof.
 */
export default class MoneroCheck {
    constructor(check) {
        Object.assign(this, check);
    }
    getIsGood() {
        return this.isGood;
    }
    setIsGood(isGood) {
        this.isGood = isGood;
        return this;
    }
}
